import React from 'react';
import CardImageHolder from '../../CardImageHolder';
import { dotFormat } from '../../../utils/dateFormat';
import { linkify } from '../../../utils/urlUtil';

const CouponCardView = ({ couponCard: { contents, coupon } }) => {
    return (
      <div className="card_default card_coupon">
        <div className="inner_card">
          <div className="wrap_thumb">
            <CardImageHolder image={coupon.entryImage} />
            <span className="frame_g" />
          </div>
          <div className="info_cont">
            <div className="wrap_tit">
              <div className="inner_tit">
                <strong className="tit_card">{coupon.title}</strong>
                <span className="txt_card">{`응모기간 : ${dotFormat(coupon.entryStartAt)}~${dotFormat(coupon.entryEndAt)}`}</span>
              </div>
            </div>
            <div className="desc_card" style={{ textAlign: 'initial' }}>
              {linkify(contents)}
            </div>
            <em className="emph_coupon">쿠폰응모는 카카오톡 앱에서 할 수 있습니다.</em>
          </div>
        </div>
      </div>
)};

export default CouponCardView;



// WEBPACK FOOTER //
// ./src/components/PostBox/media/CouponCardView.js